export const FONT_FAMILY = {
  REGULAR:
    'GrundfosTheSansOT-Regular, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  BOLD: 'GrundfosTheSansOT-Bold, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  SEMI_BOLD:
    'GrundfosTheSansOT-SemiBold, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  LIGHT:
    'GrundfosTheSansOT-Light, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  SEMI_LIGHT:
    'GrundfosTheSansOT-SemiLight, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  EXTRA_LIGHT:
    'GrundfosTheSansOT-ExtraLight, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  BLACK:
    'GrundfosTheSansOT-Black, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  EXTRA_BOLD:
    'GrundfosTheSansOT-ExtraBold, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

export const FONT_SIZE = {
  SMALL: '14px',
  MEDIUM: '16px',
  LARGE: '18px',
  XLARGE: '20px',
  TITLE: '22px',
  HEADING: '26px',
};

export const FONT_WEIGHT = {
  LIGHT: 300,
  REGULAR: 400,
  SEMI_BOLD: 600,
  BOLD: 700,
  BLACK: 900,
};
